import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"
import { useSelector } from "react-redux"

const TagsUpdateDropdown = (props) => {
	const { idItem: elementId, updateSelectIdentify } = props
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	return (
		<>
			<DropdownButton id="dropdown-basic-button-detail" size="sm" title="Identify ">
				<Dropdown.Item
					href="#/action-1"
					key={`drop_0`}
					onClick={(e) => {
						e.preventDefault()
						let tag_id = ""
						updateSelectIdentify(tag_id, elementId)
					}}
				>
					<div className="box  boxControl3" style={{ backgroundColor: "#E2E2E2" }}></div>
					<span className="ml-10">Remove tag</span>
				</Dropdown.Item>
				{tagsApi && tagsApi.hasOwnProperty("tags")
					? tagsApi.tags.map((element, i) => (
							<Dropdown.Item
								href="#/action-1"
								key={`drop_B_${element.id}`}
								onClick={(e) => {
									e.preventDefault()
									let tag_id = element.id
									updateSelectIdentify(tag_id, elementId)
								}}
							>
								<div className="box  boxControl3" style={{ backgroundColor: element.color_id }}></div>
								<span className="ml-10">{element.name}</span>
							</Dropdown.Item>
					  ))
					: null}
			</DropdownButton>
		</>
	)
}

export default TagsUpdateDropdown
